export default "__VITE_ASSET__CnuNX2DO__"